import { IHttpService } from "../HttpService";
import DynamicQuery, {
  IDynamicQuery
} from "../../model/dynamicQuery/DynamicQuery";

export interface IDynamicQueryService {
  getDynamicQueries(): Promise<IDynamicQuery[]>;
  createDynamicQuery(dynamicQuery: IDynamicQuery): Promise<any>;
  updateDynamicQuery(code: string, dynamicQuery: IDynamicQuery): Promise<any>;
  deleteDynamicQuery(code: string): Promise<any>;
}

const DynamicQueryService = (httpService): IDynamicQueryService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _dynamicQueriesPath = "/dynamic-queries";

  const DynamicQueryMapper = (json = []) => {
    return json.map((item: any) => {
      return DynamicQuery(item);
    });
  };

  return {
    async getDynamicQueries() {
      const path = _http.buildPath(_baseUrl, _dynamicQueriesPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return DynamicQueryMapper(responseJSON);
    },
    async createDynamicQuery(dynamicQuery: IDynamicQuery) {
      const path = _http.buildPath(_baseUrl, _dynamicQueriesPath);
      const response = await _http.post(path, {
        params: { ...dynamicQuery }
      });
      return _http.toText(response);
    },
    async updateDynamicQuery(code: string, dynamicQuery: IDynamicQuery) {
      const path = _http.buildPath(_baseUrl, _dynamicQueriesPath, code);
      const response = await _http.put(path, {
        params: dynamicQuery
      });
      return _http.toText(response);
    },
    async deleteDynamicQuery(code: string) {
      const path = _http.buildPath(_baseUrl, _dynamicQueriesPath, code);
      const response = await _http.remove(path);
      return _http.toText(response);
    }
  };
};

export default DynamicQueryService;
